export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11630.c957fe95.jpg";